import { clearCookieUserAndSSO } from 'src/features/Auth/Login/SSOLogout';
import { RevokeTokenSuccess } from 'src/session';
import { ThunkActionCreator } from 'src/store/types';
import { handleLogout as _handleLogout } from './authentication.actions';
import { Dispatch } from 'redux';
import { accountLogout } from 'src/services/account';
import { reportException } from 'src/exceptionReporting';
import { MoxoAccessManager } from 'src/pages/Applications/commons/Moxo/Client/MoxoAccessManager';
// import { MoxoClient } from 'src/services/moxo/adapter';

/**
 * Revokes auth token used to make HTTP requests
 *
 */

export const handleLogout: ThunkActionCreator<
  Promise<RevokeTokenSuccess>,
  {
    data: any;
  }
> = (data: any) => (dispatch: Dispatch<any>, _getStore: any) => {
  return accountLogout(data)
    .then((response: any) => {
      return response;
    })
    .catch((err: any) => {
      reportException(`<------Logout Handler -- ${err}------>`);
      return err;
    })
    .finally(() => {
      dispatch(_handleLogout());
      clearCookieUserAndSSO();
      const moxoAccessManager = new MoxoAccessManager();
      moxoAccessManager.destroy()

    });
};
